import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import { getCatalogFiltersBarOpenState } from 'store/ProductCatalog/controls/selectors';
import { setFiltersBarClose } from 'store/ProductCatalog/controls/actions';
import { FixedOverlay } from 'components';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export function MobilePanel({ children, isOpen, onClose }) {
  return (
    <CSSTransition
      in={isOpen}
      classNames={{
        enter: cx('enter'),
        enterActive: cx('enter-active'),
        exit: cx('exit'),
        exitActive: cx('exit-active'),
      }}
      timeout={300}
      unmountOnExit
    >
      <FixedOverlay onClose={onClose} className={cx('overlay')} isOpen>
        {children}
      </FixedOverlay>
    </CSSTransition>
  );
}

MobilePanel.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

const mapStateToProps = (state) => ({
  isOpen: getCatalogFiltersBarOpenState(state),
});

const mapDispatchToProps = {
  onClose: setFiltersBarClose,
};

export default connect(mapStateToProps, mapDispatchToProps)(MobilePanel);
